import type { JavaScriptVariableState } from '@unifyapps/defs/types/javascriptVariable';

export function adaptPageVariablesForContext(
  pageVariables: Record<string, JavaScriptVariableState | undefined>,
) {
  // Page variable is stored in store as:
  // {
  //   [variableName: string]: {
  //     initialValue: any;
  //     value: any;
  //     type: string;
  //   };
  // }
  // but we are showing it in the input data pill picker as
  // {
  //   [variableName: string]: value
  // }
  // so we are adapting the page variables to the format that is used in the input data pill picker

  const pageVariablesValues: Record<string, unknown> = {};
  const keys = Object.keys(pageVariables);
  const keysLength = keys.length;

  for (let i = 0; i < keysLength; i++) {
    const key = keys[i];
    if (pageVariables[key]) pageVariablesValues[key] = pageVariables[key].value;
  }

  return pageVariablesValues;
}
